export enum TripEventType {
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  ETA = 'ETA',
  HANDOVER_RELEASE = 'HANDOVER_RELEASE',
  HANDOVER_TAKE = 'HANDOVER_TAKE',
}
